import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { HisMultiselectComponent } from './his-multiselect.component';
import { GenericValue } from '../../../core/model/generic-value';
import { HisOptionXtd } from '../../../core/model/his-option';

@Component( {
    selector: 'his-multiselect-plam',
    templateUrl: './his-multiselect-plam.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HisMultiselectPlamComponent),
            multi: true,
        },
    ],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
} )
export class HisMultiselectPlamComponent<T extends HisOptionXtd | GenericValue = HisOptionXtd> extends HisMultiselectComponent<T> {}